/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfLicence } from '../models';
// @ts-ignore
import type { BfLicenceAssignment } from '../models';
/**
 * LicencingApi - axios parameter creator
 */
export const LicencingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a user to a particular licence
         * @summary Assign licence
         * @param {BfLicenceAssignment} bfLicenceAssignment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLicenceToUser: async (bfLicenceAssignment: BfLicenceAssignment, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfLicenceAssignment' is not null or undefined
            assertParamExists('assignLicenceToUser', 'bfLicenceAssignment', bfLicenceAssignment)
            const localVarPath = `/v1/licencing/assignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfLicenceAssignment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a user to a particular licence
         * @summary Assign managers to a licence
         * @param {BfLicence} bfLicence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignManagerToLicence: async (bfLicence: BfLicence, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfLicence' is not null or undefined
            assertParamExists('assignManagerToLicence', 'bfLicence', bfLicence)
            const localVarPath = `/v1/licencing/assignment/manager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfLicence, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an assignable licence.
         * @summary Create licence
         * @param {BfLicence} bfLicence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLicence: async (bfLicence: BfLicence, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfLicence' is not null or undefined
            assertParamExists('createLicence', 'bfLicence', bfLicence)
            const localVarPath = `/v1/licencing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfLicence, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unassign all users and delete the licence
         * @summary Delete licence
         * @param {string} deleteLicenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLicence: async (deleteLicenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteLicenceId' is not null or undefined
            assertParamExists('deleteLicence', 'deleteLicenceId', deleteLicenceId)
            const localVarPath = `/v1/licencing/{delete_licence_id}`
                .replace(`{${"delete_licence_id"}}`, encodeURIComponent(String(deleteLicenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List which users the user can assign
         * @summary List licences
         * @param {boolean} [detail] Include user lookup detail
         * @param {string} [token] Token for other queries
         * @param {string} [licenceId] Look for a specific licence id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignableLicences: async (detail?: boolean, token?: string, licenceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/licencing/assignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (detail !== undefined) {
                localVarQueryParameter['detail'] = detail;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (licenceId !== undefined) {
                localVarQueryParameter['licenceId'] = licenceId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lookup a particular licence
         * @summary Get licence
         * @param {string} licenceId 
         * @param {boolean} [detail] Include user detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLicenceById: async (licenceId: string, detail?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'licenceId' is not null or undefined
            assertParamExists('getLicenceById', 'licenceId', licenceId)
            const localVarPath = `/v1/licencing/licence/{licence_id}`
                .replace(`{${"licence_id"}}`, encodeURIComponent(String(licenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (detail !== undefined) {
                localVarQueryParameter['detail'] = detail;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lookup a particular licence
         * @summary Get licence, deprecated
         * @param {string} licenceId 
         * @param {boolean} [detail] Include user detail
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLicenceByIdDeprecated: async (licenceId: string, detail?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'licenceId' is not null or undefined
            assertParamExists('getLicenceByIdDeprecated', 'licenceId', licenceId)
            const localVarPath = `/v1/licencing/licnece/{licence_id}`
                .replace(`{${"licence_id"}}`, encodeURIComponent(String(licenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (detail !== undefined) {
                localVarQueryParameter['detail'] = detail;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove the user from a particular licence
         * @summary Unassign licence
         * @param {BfLicenceAssignment} bfLicenceAssignment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignLicenceFromUser: async (bfLicenceAssignment: BfLicenceAssignment, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfLicenceAssignment' is not null or undefined
            assertParamExists('unassignLicenceFromUser', 'bfLicenceAssignment', bfLicenceAssignment)
            const localVarPath = `/v1/licencing/assignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfLicenceAssignment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a user to a particular licence
         * @summary Unassign manager from licence
         * @param {BfLicence} bfLicence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignManagerFromLicence: async (bfLicence: BfLicence, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfLicence' is not null or undefined
            assertParamExists('unassignManagerFromLicence', 'bfLicence', bfLicence)
            const localVarPath = `/v1/licencing/assignment/manager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfLicence, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a licence\'s name, expiry and limits.
         * @summary Update licence
         * @param {BfLicence} bfLicence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLicence: async (bfLicence: BfLicence, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfLicence' is not null or undefined
            assertParamExists('updateLicence', 'bfLicence', bfLicence)
            const localVarPath = `/v1/licencing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfLicence, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LicencingApi - functional programming interface
 */
export const LicencingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LicencingApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a user to a particular licence
         * @summary Assign licence
         * @param {BfLicenceAssignment} bfLicenceAssignment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignLicenceToUser(bfLicenceAssignment: BfLicenceAssignment, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfLicence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignLicenceToUser(bfLicenceAssignment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicencingApi.assignLicenceToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a user to a particular licence
         * @summary Assign managers to a licence
         * @param {BfLicence} bfLicence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignManagerToLicence(bfLicence: BfLicence, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfLicence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignManagerToLicence(bfLicence, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicencingApi.assignManagerToLicence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an assignable licence.
         * @summary Create licence
         * @param {BfLicence} bfLicence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLicence(bfLicence: BfLicence, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfLicence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLicence(bfLicence, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicencingApi.createLicence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unassign all users and delete the licence
         * @summary Delete licence
         * @param {string} deleteLicenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLicence(deleteLicenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLicence(deleteLicenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicencingApi.deleteLicence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List which users the user can assign
         * @summary List licences
         * @param {boolean} [detail] Include user lookup detail
         * @param {string} [token] Token for other queries
         * @param {string} [licenceId] Look for a specific licence id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssignableLicences(detail?: boolean, token?: string, licenceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfLicence>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssignableLicences(detail, token, licenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicencingApi.getAssignableLicences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lookup a particular licence
         * @summary Get licence
         * @param {string} licenceId 
         * @param {boolean} [detail] Include user detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLicenceById(licenceId: string, detail?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfLicence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLicenceById(licenceId, detail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicencingApi.getLicenceById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lookup a particular licence
         * @summary Get licence, deprecated
         * @param {string} licenceId 
         * @param {boolean} [detail] Include user detail
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getLicenceByIdDeprecated(licenceId: string, detail?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfLicence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLicenceByIdDeprecated(licenceId, detail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicencingApi.getLicenceByIdDeprecated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove the user from a particular licence
         * @summary Unassign licence
         * @param {BfLicenceAssignment} bfLicenceAssignment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignLicenceFromUser(bfLicenceAssignment: BfLicenceAssignment, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfLicence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignLicenceFromUser(bfLicenceAssignment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicencingApi.unassignLicenceFromUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a user to a particular licence
         * @summary Unassign manager from licence
         * @param {BfLicence} bfLicence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignManagerFromLicence(bfLicence: BfLicence, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfLicence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignManagerFromLicence(bfLicence, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicencingApi.unassignManagerFromLicence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a licence\'s name, expiry and limits.
         * @summary Update licence
         * @param {BfLicence} bfLicence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLicence(bfLicence: BfLicence, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfLicence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLicence(bfLicence, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LicencingApi.updateLicence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LicencingApi - factory interface
 */
export const LicencingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LicencingApiFp(configuration)
    return {
        /**
         * Add a user to a particular licence
         * @summary Assign licence
         * @param {BfLicenceAssignment} bfLicenceAssignment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLicenceToUser(bfLicenceAssignment: BfLicenceAssignment, options?: RawAxiosRequestConfig): AxiosPromise<BfLicence> {
            return localVarFp.assignLicenceToUser(bfLicenceAssignment, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a user to a particular licence
         * @summary Assign managers to a licence
         * @param {BfLicence} bfLicence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignManagerToLicence(bfLicence: BfLicence, options?: RawAxiosRequestConfig): AxiosPromise<BfLicence> {
            return localVarFp.assignManagerToLicence(bfLicence, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an assignable licence.
         * @summary Create licence
         * @param {BfLicence} bfLicence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLicence(bfLicence: BfLicence, options?: RawAxiosRequestConfig): AxiosPromise<BfLicence> {
            return localVarFp.createLicence(bfLicence, options).then((request) => request(axios, basePath));
        },
        /**
         * Unassign all users and delete the licence
         * @summary Delete licence
         * @param {string} deleteLicenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLicence(deleteLicenceId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteLicence(deleteLicenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * List which users the user can assign
         * @summary List licences
         * @param {boolean} [detail] Include user lookup detail
         * @param {string} [token] Token for other queries
         * @param {string} [licenceId] Look for a specific licence id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignableLicences(detail?: boolean, token?: string, licenceId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BfLicence>> {
            return localVarFp.getAssignableLicences(detail, token, licenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lookup a particular licence
         * @summary Get licence
         * @param {string} licenceId 
         * @param {boolean} [detail] Include user detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLicenceById(licenceId: string, detail?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<BfLicence> {
            return localVarFp.getLicenceById(licenceId, detail, options).then((request) => request(axios, basePath));
        },
        /**
         * Lookup a particular licence
         * @summary Get licence, deprecated
         * @param {string} licenceId 
         * @param {boolean} [detail] Include user detail
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLicenceByIdDeprecated(licenceId: string, detail?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<BfLicence> {
            return localVarFp.getLicenceByIdDeprecated(licenceId, detail, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove the user from a particular licence
         * @summary Unassign licence
         * @param {BfLicenceAssignment} bfLicenceAssignment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignLicenceFromUser(bfLicenceAssignment: BfLicenceAssignment, options?: RawAxiosRequestConfig): AxiosPromise<BfLicence> {
            return localVarFp.unassignLicenceFromUser(bfLicenceAssignment, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a user to a particular licence
         * @summary Unassign manager from licence
         * @param {BfLicence} bfLicence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignManagerFromLicence(bfLicence: BfLicence, options?: RawAxiosRequestConfig): AxiosPromise<BfLicence> {
            return localVarFp.unassignManagerFromLicence(bfLicence, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a licence\'s name, expiry and limits.
         * @summary Update licence
         * @param {BfLicence} bfLicence 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLicence(bfLicence: BfLicence, options?: RawAxiosRequestConfig): AxiosPromise<BfLicence> {
            return localVarFp.updateLicence(bfLicence, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LicencingApi - object-oriented interface
 */
export class LicencingApi extends BaseAPI {
    /**
     * Add a user to a particular licence
     * @summary Assign licence
     * @param {BfLicenceAssignment} bfLicenceAssignment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignLicenceToUser(bfLicenceAssignment: BfLicenceAssignment, options?: RawAxiosRequestConfig) {
        return LicencingApiFp(this.configuration).assignLicenceToUser(bfLicenceAssignment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a user to a particular licence
     * @summary Assign managers to a licence
     * @param {BfLicence} bfLicence 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignManagerToLicence(bfLicence: BfLicence, options?: RawAxiosRequestConfig) {
        return LicencingApiFp(this.configuration).assignManagerToLicence(bfLicence, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an assignable licence.
     * @summary Create licence
     * @param {BfLicence} bfLicence 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createLicence(bfLicence: BfLicence, options?: RawAxiosRequestConfig) {
        return LicencingApiFp(this.configuration).createLicence(bfLicence, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unassign all users and delete the licence
     * @summary Delete licence
     * @param {string} deleteLicenceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteLicence(deleteLicenceId: string, options?: RawAxiosRequestConfig) {
        return LicencingApiFp(this.configuration).deleteLicence(deleteLicenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List which users the user can assign
     * @summary List licences
     * @param {boolean} [detail] Include user lookup detail
     * @param {string} [token] Token for other queries
     * @param {string} [licenceId] Look for a specific licence id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssignableLicences(detail?: boolean, token?: string, licenceId?: string, options?: RawAxiosRequestConfig) {
        return LicencingApiFp(this.configuration).getAssignableLicences(detail, token, licenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lookup a particular licence
     * @summary Get licence
     * @param {string} licenceId 
     * @param {boolean} [detail] Include user detail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLicenceById(licenceId: string, detail?: boolean, options?: RawAxiosRequestConfig) {
        return LicencingApiFp(this.configuration).getLicenceById(licenceId, detail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lookup a particular licence
     * @summary Get licence, deprecated
     * @param {string} licenceId 
     * @param {boolean} [detail] Include user detail
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public getLicenceByIdDeprecated(licenceId: string, detail?: boolean, options?: RawAxiosRequestConfig) {
        return LicencingApiFp(this.configuration).getLicenceByIdDeprecated(licenceId, detail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove the user from a particular licence
     * @summary Unassign licence
     * @param {BfLicenceAssignment} bfLicenceAssignment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unassignLicenceFromUser(bfLicenceAssignment: BfLicenceAssignment, options?: RawAxiosRequestConfig) {
        return LicencingApiFp(this.configuration).unassignLicenceFromUser(bfLicenceAssignment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a user to a particular licence
     * @summary Unassign manager from licence
     * @param {BfLicence} bfLicence 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unassignManagerFromLicence(bfLicence: BfLicence, options?: RawAxiosRequestConfig) {
        return LicencingApiFp(this.configuration).unassignManagerFromLicence(bfLicence, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a licence\'s name, expiry and limits.
     * @summary Update licence
     * @param {BfLicence} bfLicence 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateLicence(bfLicence: BfLicence, options?: RawAxiosRequestConfig) {
        return LicencingApiFp(this.configuration).updateLicence(bfLicence, options).then((request) => request(this.axios, this.basePath));
    }
}

